/** Unicode dash/hyphen variants → ASCII hyphen (matches backend `_DASH_CHARS`). */
const UNICODE_DASHES = /[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D-]+/g

/**
 * Matches backend `close_modality_intent.is_close_modality_command` (EN/FR).
 * Used to skip opening a blank intent tab when the user only wants to close the exam preview.
 */
export function isCloseModalityCommand(text: string): boolean {
  const raw = text.trim()
  if (!raw) return false
  const t = raw
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(UNICODE_DASHES, '-')
    .replace(/\s+/g, ' ')
    .replace(/[-.,!?;:]+$/, '')
    .trim()

  const exact = new Set([
    'close',
    'close it',
    'close this',
    'close that',
    'dismiss',
    'dismiss it',
    'hide it',
    'hide',
    'ferme',
    'ferme le',
    'ferme la',
    'ferme ca',
    'ferme ça',
    'fermer',
    'fermer le',
    'fermer-le',
    'ferme-le',
    'fermez-le',
    'ferme le',
    'fermez le',
    'ferme la',
    'fermez la',
  ])
  if (exact.has(t)) return true
  if (
    /^(close|hide|dismiss)(\s+(the|this|that))?\s+(file|document|exam|preview|window|ecg|x-?ray|mri|ct|scan|image|ultrasound|echo)\b/.test(
      t,
    )
  )
    return true
  if (/^(close|hide|dismiss)\s+(it|this|that)\s*$/.test(t)) return true
  if (/^ferme(\s+le|\s+la|\s+l')?\s*(fichier|document|examen|apercu|aperçu|fenetre|fenêtre)\b/.test(t)) return true
  if (/^fermez?\s+(ça|cela|le|la)\s*$/.test(t)) return true
  if (/^fermer?z?-?(le|la|it|ça|cela)\s*$/.test(t)) return true
  return false
}
